export const receivingTrackService = async (track: string) => {
    try {
        const res = await fetch('/api/receivingTrack', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(track),
        });

        if (!res.ok) {
            const errorText = await res.text();
            throw new Error(`Ошибка: ${res.status} - ${errorText}`);
        }

        return await res.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};
